import { Environment } from '@delon/theme';

export const environment = {
  production: true,
  stage: 'prod',
  useHash: true,
  useReportingHostPreview: false,
  reportingShellOrigin: 'https://reporting.qne.cloud',
  api: {
    baseUrl: 'https://qca-s1.azurewebsites.net/',
    ai: 'https://qca-s1-ai-prod.azurewebsites.net/',
    reporting: 'https://qca-s4.azurewebsites.net/',
    reporting_mirror: 'https://qca-s3.azurewebsites.net/',
    signalrUrl: 'https://qca-s4-signalr.azurewebsites.net/',
    open: 'https://openapi.account.qne.cloud',
    uobUat: 'https://account-api.qne.cloud',
    uobProd: 'https://api.account.qne.cloud',
    refreshTokenEnabled: false,
    refreshTokenType: 'auth-refresh'
  }
} as Environment;
